import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const style: CSSResult = css`
    :host {
        --cse-tab-panel-padding-y: ${csSpacing.spacing08} 0;
        --cse-tab-panel-padding-x: 0;
    }
`
